// Receipt link of the payment gateway (`{gateway}/api/receipts/{token}`): with `download=1` the PDF is saved as a file
// (`receipt-{invoiceNumber}.pdf`) instead of being opened in the browser.
export const receiptDownloadUrl = (receiptUrl: string): string =>
	`${receiptUrl}${receiptUrl.includes('?') ? '&' : '?'}download=1`;

// Starts the download of a receipt from code (e.g. a table action): the gateway answers with Content-Disposition: attachment,
// so the current page stays where it is.
export const downloadReceipt = (receiptUrl: string): void => {
	const link = document.createElement('a');
	link.href = receiptDownloadUrl(receiptUrl);
	link.rel = 'noopener';
	document.body.appendChild(link);
	link.click();
	link.remove();
};
